<template>
  <v-form v-model='valid' ref='form' lazy-validation>
    <v-container>
      <v-layout align-center justify-end v-if='!modificar'>
        <v-btn fab color="primary" class="botonEdit" @click='modificarDatos()'>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-layout>
      <v-layout wrap>
        <v-flex xs6 md3>
          <h6>Documento de Identificación</h6>
          <p><strong>{{this.tipoDocumento}}</strong></p>
        </v-flex>
        <v-flex xs6 md3>
         <h6> Número de Documento</h6>
          <p><strong>{{this.numeroDocumento}}</strong></p>
        </v-flex>
        <v-flex xs6 md3>
        <h6> Fecha de Nacimiento</h6>
          <p><strong>{{this.formatFechaNacimiento}}</strong></p>
        </v-flex>
        <v-flex xs6 md3>
         <h6> Género</h6>
          <p><strong>{{this.itemsGenero[this.genero].tipgen_descripcion || ''}}</strong></p>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs6 md3>
       <h6>Apellido Paterno</h6>
          <p><strong>{{this.apellidoPaterno}}</strong></p>
        </v-flex>
        <v-flex xs6 md3>
          <h6>Apellido Materno</h6>
          <p><strong>{{this.apellidoMaterno}}</strong></p>
        </v-flex>
        <v-flex xs6 md3>
         <h6>Nombres</h6>
          <p><strong>{{this.nombres}}</strong></p>
        </v-flex>
      </v-layout>
    </v-container>
    <h4>Datos Complementarios</h4>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-select
          :no-data-text="$t('comun.sin_datos')"
            @change='despliegaPaisOrigen()'
            v-model="nacionalidad"
            :items="itemsNacionalidad"
            item-text='tipnac_descripcion'
            item-value='tipnac_codigo'
            label='Nacionalidad'
            :disabled='!modificar'
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-autocomplete
          :no-data-text="$t('comun.sin_datos')"
            v-model="paisOrigen"
            :items="itemsPaises"
            item-text='pai_descripcion'
            item-value='pai_codigo'
            label='País de Nacimiento'
            :disabled='!modificar'
            v-show='!paisNacimiento'
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>ESTADO CIVIL Seleccionar el estado civil a la fecha de la declaración.</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-select
              :no-data-text="$t('comun.sin_datos')"
              @change="despliegaApellidoCasada()"
              v-model="estadoCivil"
              :items="itemsEstadoCivil"
              item-text='estciv_descripcion'
              item-value='estciv_codigo'
              label='Estado Civil*'
              :disabled='!modificar'
              :rules='dRules'
              required
            ></v-select>
          </v-layout>
         </v-flex> 
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='verApellidoCasada'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>APELLIDO DE CASADA Ingresar únicamente si el Apellido de Casada figura en el documento de identidad.</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-text-field
              v-model="apellidoCasada"
              label='Apellido de Casada'
              :disabled='!modificar'
              maxlength='50'
              @keyup="apellidoCasada = apellidoCasada ? apellidoCasada.replace(/[-_/.*(),.;:]/g, '') : ''"
              v-show='verApellidoCasada'  
            ></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>DOMICILIO ACTUAL Se refiere a los datos del domicilio donde vive el declarante, independientemente del lugar donde presta servicios. Se deberá indicar Calle/Avenida, Zona, Numeración, Piso, etc. o si no se tiene esos datos, cualquier información referencial que identifique la ubicación del domicilio.</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-text-field
              v-model="domicilioActual"
              label='Domicilio Actual (Calle/Avenida Nro, Zona, Numeración, Piso, etc.)*'
              :rules='dRules'
              required
              :disabled='!modificar'
              maxlength='100'
              @keyup="domicilioActual = domicilioActual ? domicilioActual.replace(/['%{}*]/g, '') : ''"
            ></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
            <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
          <v-textarea
            @change="observaciones = $util.sanitiza(observaciones)"
            v-model="observaciones"
            label='Observaciones'
            :disabled='!modificar'
            v-on='on'
            maxlength='250'
            :counter='250'
            hint='Máximo 250 caracteres.'
            persistent-hint
            :rules="$validate(['text_area'])"
            rows="1"
            auto-grow
          ></v-textarea>
          </template>
            <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos consignados en los Subtítulos "Datos personales del declarante".</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <br>
      <v-layout wrap>
        <v-flex sm12 md12>
          <v-subheader><p class='plomo--text'>Por favor llene los campos requeridos*</p></v-subheader>
        </v-flex>
      </v-layout>
      <v-btn color='primary' @click='modificarDatos()' v-show='!modificar'>
        <v-icon>create</v-icon>&nbsp;Modificar
      </v-btn>
      <v-btn :loading='loadingButton' color='primary' @click='guardaDatosPersonales' v-show='modificar'>
        <v-icon>save</v-icon>&nbsp;Guardar
      </v-btn>
      <v-btn color='error' v-show='modificar' @click='cancelarAction'>
        <v-icon>cancel</v-icon>&nbsp;Cancelar
      </v-btn>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
var convert = require('xml-js');
export default {
  mixins: [ Parametricas, validate ],
  mounted () {
    this.$root.$on('clickedGuardarDatosPersonales', () => {
      this.guardaDatosPersonales();
    });
  },
  async created () {
    await this.obtieneDatos();
    if (this.itemsNacionalidad.length === 0) {
      this.obtenerTiposNacionalidadParametrica().then(respuesta => {
        this.itemsNacionalidad = respuesta.datos;
      });
    }
    if (this.itemsEstadoCivil.length === 0) {
      this.obtenerEstadosCivilesParametrica().then(respuesta => {
        this.itemsEstadoCivil = respuesta.datos;
      });
    }
    if (this.itemsPaises.length === 0) {
      this.obtenerPaisesParametrica().then(respuesta => {
        this.itemsPaises = respuesta.datos;
      });
    }
    this.despliegaPaisOrigen();
    // this.despliegaApellidoCasada();
  },

  data: () => ({
    loadingButton: false,
    tipoDocumento: 0,
    numeroDocumento: '',
    expedicion: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    apellidoCasada: '',
    nombres: '',
    genero: 0,
    fechaNacimiento: new Date().toISOString().substr(0, 10),
    nacionalidad: 0,
    paisOrigen: null,
    estadoCivil: null,
    domicilioActual: '',
    observaciones: '',
    paisNacimiento: false,
    verApellidoCasada: false,
    datosGeneralesServicio: null,
    itemsGenero: [
      {
        tipgen_codigo: 0,
        tipgen_descripcion: 'FEMENINO'
      },
      {
        tipgen_codigo: 1,
        tipgen_descripcion: 'MASCULINO'
      }
    ],
    itemsNacionalidad: [],
    itemsEstadoCivil: [],
    itemsPaises: [],
    menu: false,
    modificar: false,
    valid: true,
    dRules: [v => !!v || 'Este campo es requerido']
  }),
  methods: {
    setearDatos (response) {
      let docidentidad = response.perdec_docidentidad.split('_');
      this.expedicion = response.dep_descripcion;
      this.genero = response.perdec_genero;
      this.tipoDocumento = response.tipdoc_descripcion;
      this.numeroDocumento = response.tipdoc_codigo === 3 ? `${docidentidad[1]}-${docidentidad[2]}` : response.perdec_docidentidad.replace(/[^A-Z0-9]/g, '');
      this.apellidoPaterno = response.perdec_appaterno;
      this.apellidoMaterno = response.perdec_apmaterno;
      this.nombres = response.perdec_nombres;
      this.fechaNacimiento = response.perdec_fecha_nacimiento;
      this.paisOrigen = response.pai_origen_codigo;
      if (response.estciv_codigo !== null || response.decjur_domicilio_documento !== '') {
        this.estadoCivil = response.estciv_codigo;
        this.apellidoCasada = response.datcom_apcasada;
        this.nacionalidad = response.tipnac_codigo;
        this.domicilioActual = response.decjur_domicilio_documento;
        this.observaciones = JSON.parse(
          convert.xml2json(response.obs_descripcion, { compact: true, spaces: 4 })
        ).table.row.observacion._text;
        if (this.observaciones === 'NULL') {
          this.observaciones = '';
        }
        this.modificar = false;
      } else {
        this.modificar = true;
      }
      this.despliegaPaisOrigen();
      this.despliegaApellidoCasada();
    },
    async obtieneDatos () {
      await this.$service.get(`djbr_registro/datos_declarante`).then(async response => {
        if (response) {
          this.mensajeValidacion = response.err_existente;
          if (response.err_existente === 1) {
            this.modificar = true;
            // let ctrl = this.$storage.get('ctrl');
            // ctrl.datos_generales.datos_personales = true;
            // this.$storage.set('ctrl', ctrl);
          }
          this.datosGeneralesServicio = response;
          await this.setearDatos(response);
        } else {
          this.$message['warning'](`No se recuperaron datos personales..`);
        }
      });
    },

    guardaDatosPersonales () {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        let params = {
          cod_nacionalidad: this.nacionalidad, // tipnac_codigo
          tipo_documento: this.datosGeneralesServicio.tipdoc_codigo, // tipdoc_cdigo Este campo no se actualiza
          nro_documento: this.datosGeneralesServicio.perdec_docidentidad.replace(/[^A-Z0-9]/g, ''),
          lugar_expedicion: this.datosGeneralesServicio.dep_expedicion_codigo, // dep_expedicion_codigo Este campo no se actualiza
          ap_paterno: this.datosGeneralesServicio.perdec_appaterno, // no se actualiza
          ap_materno: this.datosGeneralesServicio.perdec_apmaterno, // no se actualiza
          ap_casada: this.apellidoCasada,
          nombres: this.datosGeneralesServicio.perdec_nombres, // no se actualiza
          genero: this.datosGeneralesServicio.perdec_genero, // no se actualiza si no es nulo
          fecha_nacimiento: this.datosGeneralesServicio.perdec_fecha_nacimiento,
          cod_estado_civil: this.estadoCivil,
          correo_electronico: this.datosGeneralesServicio.datcom_correo_electronico,
          telefono_celular: this.datosGeneralesServicio.datcom_telefono_movil,
          domicilio: this.domicilioActual, // decjur_domicilio_documento
          direccion_laboral: '', // DATO DE INFORMACION NO SE TIENE  POR SERVICIO NI EN FORMULARIO, ADEMAS SE SE VIO QUE ESTE CAMPO NO TIENE INFORMACION EN NINGUN CASO
          codigo_observacion: this.datosGeneralesServicio.obs_codigo,
          xml_desc_obs: `<table xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance'><row><observacion>${this.observaciones ? this.observaciones.toUpperCase() : ''}</observacion></row></table>`,
          cod_pais_origen: this.paisOrigen // this.responce.pai_origen_codigo
        };
        this.$service
          .post(`djbr_registro/datos_declarante`, params)
          .then(response => {
            if (response) {
              if (response.err_codigo === 0) {
                this.loadingButton = false;
                // this.obtieneDatos();
                this.editMode = false;
                this.dialog = false;
                this.$message['success'](response.err_mensaje);
                if (this.datosGeneralesServicio.estciv_codigo !== this.estadoCivil) {
                  this.EstCivEmmit();
                }
                let ctrl = this.$storage.get('ctrl');
                ctrl.datos_generales.datos_personales = false;
                this.$storage.set('ctrl', ctrl);
              } else {
                this.$message['warning'](response.err_mensaje);
                this.loadingButton = false;
              }
              this.cancelarAction(1);
            } else {
              this.loadingButton = false;
            }
          })
          .catch(e => {
            console.log(e);
            this.loadingButton = false;
          });
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    despliegaPaisOrigen () {
      if (this.nacionalidad === 1) {
        // 1: BOLIVIANO(A)
        this.paisNacimiento = true;
      } else {
        this.paisNacimiento = false;
      }
    },
    despliegaApellidoCasada () {
      if (this.itemsGenero[this.genero].tipgen_descripcion === 'FEMENINO' && (this.estadoCivil === 1 || this.estadoCivil === 4)) { // 1:CASADO(A)
        this.verApellidoCasada = true;
      } else {
        if (this.itemsGenero[this.genero].tipgen_descripcion === 'MASCULINO' && this.apellidoCasada !== '') {
          this.verApellidoCasada = true;
          this.$message['warning']('DEBE BORRAR SU APELLIDO DE CASADA NO CORRESPONDE');
        } else {
          this.verApellidoCasada = false;
          this.apellidoCasada = '';
        }
      }
    },
    cancelarAction (tipo) {
      this.cod_error = null;
      this.modificar = !this.modificar;
      if (tipo !== 1) {
        this.obtieneDatos();
      }
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.datos_personales = false;
      this.$storage.set('ctrl', ctrl);
      this.$refs.form.resetValidation();
    },
    modificarDatos () {
      this.modificar = !this.modificar;
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.datos_personales = true;
      this.$storage.set('ctrl', ctrl);
    }
  },
  computed: {
    formatFechaNacimiento () {
      if (!this.fechaNacimiento) return null;
      const [year, month, day] = this.fechaNacimiento.split('-');
      return `${day}/${month}/${year}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datosGenerales/datosPersonales.vue